export interface ISiteEmailSettings {
  emailFrom: string;
  logoUrl?: string;
  lockNotificationOffsetDays?: number;
  localizedFrequency?: string;
  enableCustomerErrorEmailsBcc: boolean;
  customerErrorEmailsBccEmail?: string;

  // Notification Providers (0 = QPilot, 1 = 3rd Party)
  upcomingNotificationProvider: number;
  lockNotificationProvider: number;
  scheduledOrderUpdatesNotificationProvider: number;
  scheduledOrderErrorsNotificationProvider: number;

  // Scheduled Order Days Notifications
  siteScheduleOrdersDaysEmailNotifications: IScheduledOrderDaysNotification[];
  maxSiteScheduleOrdersDaysEmailNotifications: number;

  // Scheduled Order Upcoming Error Settings
  scheduledOrderUpcomingErrorEmailSettings: IScheduledOrderErrorEmailSetting[];
  enableScheduledOrderUpcomingErrorEmailsBcc: boolean;
  scheduledOrderUpcomingErrorEmailBccEmail?: string;

  // Lock Notifications
  enableScheduledOrderLockNotificationEmail: boolean;

  // Status Update Notifications
  enableScheduledOrderCreatedNotificationEmail: boolean;
  enableScheduledOrderPausedNotificationEmail: boolean;
  enableScheduledOrderDeletedNotificationEmail: boolean;
  enableScheduledOrderPaymentAuthNotificationEmail: boolean;

  // Error Email Settings
  scheduledOrderErrorEmailSettings: IScheduledOrderErrorEmailSetting[];
  scheduledOrderLockErrorEmailSettings?: IScheduledOrderErrorEmailSetting[];

  // Additional Settings
  allowRetryScheduledOrder?: boolean;

  // Template Settings
  emailTemplatesStyleSettings?: IEmailTemplateStyleSettings;
  defaultEmailTemplatesStyleSettings?: IEmailTemplateStyleSettings;

  // Localization Keys
  emailTemplateLocalizationKeys?: IEmailTemplateLocalizationKeys;

  // Individual Template Settings
  numberOfDaysEmailTemplateSettings?: IEmailTemplateSetting;
  defaultNumberOfDaysEmailTemplateSettings?: IEmailTemplateSetting;

  lockNotificationsEmailTemplateSettings?: IEmailTemplateSetting;
  defaultLockNotificationsEmailTemplateSettings?: IEmailTemplateSetting;

  scheduledOrderCreatedEmailTemplateSettings?: IEmailTemplateSetting;
  defaultScheduledOrderCreatedEmailTemplateSettings?: IEmailTemplateSetting;

  scheduledOrderPausedEmailTemplateSettings?: IEmailTemplateSetting;
  defaultScheduledOrderPausedEmailTemplateSettings?: IEmailTemplateSetting;

  scheduledOrderDeletedEmailTemplateSettings?: IEmailTemplateSetting;
  defaultScheduledOrderDeletedEmailTemplateSettings?: IEmailTemplateSetting;

  scheduledOrderPaymentAuthEmailTemplateSettings?: IEmailTemplateSetting;
  defaultScheduledOrderPaymentAuthEmailTemplateSettings?: IEmailTemplateSetting;
}

export interface IScheduledOrderDaysNotification {
  id?: number;
  siteId: number;
  days: number;
  enabled: boolean;
}

export interface IScheduledOrderErrorEmailSetting {
  enabled: boolean;
  scheduledOrderErrorCustomerTemplate: IScheduledOrderErrorCustomerTemplate;
}

export interface IScheduledOrderErrorCustomerTemplate {
  processingErrorCode: number;
  messageType: number;
  templateId?: string;
  emailSubject?: string;
  emailBody?: string;
}

export interface IEmailTemplateStyleSettings {
  LogoBackgroundColor?: string;
  BannerBackgroundColor?: string;
  BannerFontColor?: string;
  ScheduledOrderTableColor?: string;
  ScheduledOrderFontColor?: string;
  ContentTableColor?: string;
  BodyContainerBackgroundColor?: string;
  ContentBackgroundColor?: string;
  ContentFontColor?: string;
  CustomStyles?: string;
}

export interface IEmailTemplateSetting {
  emailSubject?: string;
  emailBody?: string;
  templateId?: string;
  isCustom?: boolean;
}

export interface IEmailTemplateLocalizationKeys {
  scheduledOrder: string;
  shippingAddress: string;
  frequency: string;
  nextOccurrence: string;
  paymentMethod: string;
  product: string;
  quantity: string;
  price: string;
  outOfStock: string;
  subtotal: string;
  shipping: string;
  tax: string;
  tbd: string;
  total: string;
  noPaymentMethod: string;
  autoshipAndSave: string;
  scheduledTaskStatusProcessing: string;
  scheduledTaskStatusSuccess: string;
  scheduledTaskStatusFailed: string;
  scheduledTaskStatusRetry: string;
  scheduledTaskStatusActive: string;
  scheduledTaskStatusPaused: string;
  scheduledTaskStatusDeleted: string;
  scheduledTaskStatusQueued: string;
  every: string;
  days: string;
  weeks: string;
  months: string;
  sunday: string;
  monday: string;
  tuesday: string;
  wednesday: string;
  thursday: string;
  friday: string;
  saturday: string;
  theNthDayOfEveryMonth: string;
  suffixSt: string;
  suffixNd: string;
  suffixRd: string;
  suffixTh: string;
}

export enum ProcessingErrorCode {
  SystemError = 99,
  EmptyScheduledOrder = 1000,
  NoItemsToShip = 1001,
  ShippingRateNotFound = 1002,
  PaymentIntegrationNotFound = 1003,
  NoPaymentMethod = 1004,
  PaymentFailed = 2000,
  PaymentFailedGatewayCommunication = 2001,
  ClientOrderCreationFailure = 3000,
  ClientOrderUpdateFailure = 3001,
  ClientOrderInvalid = 3002,
}

export enum NotificationProvider {
  QPilot = 0,
  ThirdParty = 1,
}

export enum ScheduledOrderErrorMessageType {
  Error = 0,
  Upcoming = 1,
  Lock = 3,
}
